<template>
  <section class="DoctorsList">
    <app-breadcrumb :items="items" />

    <b-container>
      <form-select
        class="PageSelect mt-5 mb-2"
        v-model="selectedUnit"
        :options="unitsOptions"
        :disabled="isLoading"
      />
    </b-container>

    <content-loader :is-loading="isLoading">
      <b-container>
        <div class="PageCard">
          <div v-if="!selectedUnit" class="PageEmptyState">
            <img
              src="../assets/images/doctors-illustration.png"
              alt="doutores"
            />
            <p class="PageParagraph mt-4">
              Selecione a unidade para qual deseja
              <br />
              configurar a agenda do profissional.
            </p>
          </div>

          <ul v-else class="PageList">
            <li v-for="doctor in doctors" :key="doctor.id" class="PageListItem">
              <app-avatar class="mr-3" :src="doctor.photo">
                {{ getInitials(doctor.name) }}
              </app-avatar>

              <div class="pageListInfo">
                <h2>{{ doctor.name }}</h2>
                <span>{{ doctor.email }}</span>
              </div>

              <div class="PageListActions">
                <app-button
                  variant="light"
                  outline
                  @click.native="configureSchedule(doctor.id)"
                >
                  Agenda
                </app-button>
              </div>
            </li>
          </ul>
        </div>
      </b-container>
    </content-loader>
  </section>
</template>

<script>
import AppBreadcrumb from "../components/AppBreadcrumb";
import ContentLoader from "../components/ContentLoader.vue";
import AppAvatar from "../components/AppAvatar";
import AppButton from "../components/AppButton";
import FormSelect from "../components/FormSelect";
import { getNameInitials } from "../utils/getNameInitials";

export default {
  name: "DoctorsList",
  components: {
    AppBreadcrumb,
    AppAvatar,
    AppButton,
    FormSelect,
    ContentLoader
  },
  data() {
    return {
      doctors: [],
      units: [],
      items: [
        {
          text: "Home",
          link: "/"
        },
        {
          text: "Profissionais"
        }
      ],
      selectedUnit: null
    };
  },
  mounted() {
    this.getUnits();
  },
  methods: {
    async getDoctors() {
      const response = await this.$store.dispatch("slot/getDoctors");
      this.doctors = response.data;
    },
    async getUnits() {
      const response = await this.$store.dispatch("slot/getUnits");
      this.units = response.data;
    },
    getInitials(text) {
      return getNameInitials(text);
    },
    configureSchedule(id) {
      this.$router.push({
        name: "ScheduleSettings",
        params: {
          unitId: this.selectedUnit,
          doctorId: id
        }
      });
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters["slot/isLoading"];
    },
    isLoadingUnits() {
      return this.$store.getters["slot/isLoadingUnits"];
    },
    unitsOptions() {
      const options = [{ label: "Unidade de atendimento", value: null }];

      return options.concat(
        this.units.map(unit => ({
          label: unit.name,
          value: unit.id
        }))
      );
    }
  },
  watch: {
    selectedUnit() {
      this.getDoctors();
    }
  }
};
</script>

<style lang="scss">
.PageTitle {
  margin: 56px 0 32px 0;
  color: #141414;
  text-align: center;
  font-size: 28px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.5px;
}

.PageParagraph {
  color: #545454;
  font-size: 16px;
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
}

.PageSelect {
  max-width: 350px;

  select {
    padding: 14px 20px;
  }
}

.PageEmptyState {
  margin: 5rem 0;
  width: 100%;

  img {
    display: block;
    margin: 0 auto;
  }

  p {
    text-align: center;
  }
}

.PageCard {
  padding: 32px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.08);
}

.PageList {
  margin: 0;
  padding: 0;
  list-style: none;
}

.PageListItem {
  padding: 1rem 0;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    border-bottom: solid 1px #eaeaea;
  }
}

.pageListInfo {
  h2 {
    margin: 0;
    color: #343a40;
    font-size: 16px;
    font-family: Public Sans;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.5px;
  }

  span {
    color: #868e96;
    text-align: right;
    font-size: 14px;
    font-family: Public Sans;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
}

.PageListActions {
  margin-left: auto;
}
</style>
